import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { loginAuthorisedAction } from '@jms/module.shell/src/state/shell.actions';
import { UtilService } from '@jms/utils';
import { Store } from '@ngrx/store';

declare const Office: any;

@Injectable({ providedIn: 'root' })
export class OutlookLoginService {

    constructor(
        private store: Store<any>,
        private router: Router
    ) { }

    public showLogin() {
        const origin = window.location.origin
        const callback = `${origin}/callback`;
        const id = `${UtilService.getIdUrl()}/logout`;
        const loginUrl = `${id}?returnUrl=${encodeURIComponent(callback)}`;
        const dialogUrl = `${origin}/auth-redirect.html?url=${encodeURIComponent(loginUrl)}`;

        Office.context.ui.displayDialogAsync(
            dialogUrl,
            { height: 60, width: 40, displayInIframe: false },
            (result: any) => {
                if (result.status !== Office.AsyncResultStatus.Succeeded) {
                    this.router.navigate(['login']);
                    return;
                }

                const dialog = result.value;
                dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg: any) => {
                    try {
                        const data = JSON.parse(arg.message);
                        if (data.token) {
                            this.store.dispatch(loginAuthorisedAction({ token: data.token, returnUrl: "" }));
                            dialog.close();
                        } else {
                            console.warn("Token invalid, redirect login");
                            dialog.close();
                            this.router.navigate(['login']);
                        }
                    } catch (e) {
                        console.error("Parse error:", e, arg.message);
                        dialog.close();
                        this.router.navigate(['login']);
                    }
                });
            }
        );
    }

    public callBackAfterLogin() {
        if (typeof Office === 'undefined' || !Office.context || !Office.context.ui) {
            console.error('Office.js not loaded in Outlook add-in');
            return;
        }

        Office.onReady(() => {
            try {
                const token = UtilService.getURLParameter('token');
                if (token) {
                    Office.context.ui.messageParent(JSON.stringify({ token }));
                } else {
                    Office.context.ui.messageParent(JSON.stringify({ error: 'No token found' }));
                }
            } catch (e: any) {
                Office.context.ui.messageParent(JSON.stringify({ error: e.message }));
            }
        });
    }
}